<script type="text/ecmascript-6">
    import DesignerQuestionDoorColourInternal from "../DesignerQuestionDoorColourInternal.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourInternal,
            TileQuestion
        ],
        mounted() {
            window.emitter.on('door-external-colour-updated', (new_colour) => {
                this.select_first();
            });
        },
        onUnmounted() {
            window.emitter.off('door-external-colour-updated');
        },
    }
</script>
